import React from 'react';
import styles from './TablePagination.module.css';
import leftArrow from '../../../assets/Imagess/leftarrowPagination.svg';
import rightArrow from '../../../assets/Imagess/RightarrowPagination.svg';

const TablePagination = ({
  page,
  itemsPerPage,
  totalPages,
  setPage,
  setPageSize,
}) => {
  const MAX_DISPLAY_PAGES = 3;

  const getPageNumbers = () => {
    const pages = [];

    if (totalPages <= MAX_DISPLAY_PAGES) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      const left = Math.max(2, page - 1);
      const right = Math.min(totalPages - 1, page + 1);

      pages.push(1);

      if (left > 2) {
        pages.push('...');
      }

      for (let i = left; i <= right; i++) {
        pages.push(i);
      }

      if (right < totalPages - 1) {
        pages.push('...');
      }

      pages.push(totalPages);
    }

    return pages;
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value, 10);
    if (!isNaN(newSize) && newSize >= 1) {
      setPageSize(newSize);
      setPage(1);
    }
  };

  return (
    <div className={styles.tablePagination}>
      <div>
        <h4>عرض: </h4>
        <div className={styles.pageSizeContainer}>
          <input
            type='number'
            onChange={handlePageSizeChange}
            value={itemsPerPage}
            min='1'
          />
        </div>
      </div>

      <ul className={styles.tablePaginationiul}>
        <li
          onClick={() => page > 1 && setPage(page - 1)}
          className={`${styles.pageItem} ${
            page === 1 ? styles.disabled : styles.inactive
          }`}
        >
          <img src={rightArrow} alt='Previous' />
        </li>

        {getPageNumbers().map((p, index) => (
          <li
            key={index}
            onClick={() => typeof p === 'number' && setPage(p)}
            className={
              typeof p === 'string'
                ? styles.ellipsis
                : `${styles.pageItem} ${
                    page === p ? styles.active : styles.inactive
                  }`
            }
          >
            {p}
          </li>
        ))}

        <li
          onClick={() => page < totalPages && setPage(page + 1)}
          className={`${styles.pageItem} ${
            page === totalPages ? styles.disabled : styles.inactive
          }`}
        >
          <img src={leftArrow} alt='Next' />
        </li>
      </ul>
    </div>
  );
};

export default TablePagination;
